import { React } from "react";
import { Link, useNavigate } from "react-router-dom";
import Panel from "../Panel";
import headerBackground from "../../Assets/Images/header-background.png";
import headerBackgroundRed from "../../Assets/Images/header-background-red.png";
import { useLocation } from "react-router-dom";

export default function Header(props) {
  const location = useLocation();

  return (
    <>
      <Panel users={props.users} bookingReference={props.bookingReference} />
      <header
        className="relative flex items-center justify-center px-8 py-16 bg-cover bg-center text-white"
        style={{
          backgroundImage:
            props.title === "skillzone"
              ? `url(${headerBackground})`
              : `url(${headerBackgroundRed})`,
        }}
      >
        <div className="align-middle flex flex-col items-center justify-center">
          {props.title === "skillzone" ? (
            <img
              className="w-[70%]"
              src={require(`./assets/skillzone-title.png`)}
              alt="share icon"
            />
          ) : (
            <img
              className="w-[60%]"
              src={require(`./assets/fixtures-title.png`)}
              alt="share icon"
            />
          )}
        </div>
      </header>
    </>
  );
}
